<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import SegmentControl from '$lib/components/molecules/segment-control/SegmentControl.svelte';
	import Allowance from '$lib/components/route-details/expense-note/Allowance.svelte';
	import {
		type ComputeMethod,
		getExpenseNoteContext,
	} from '$lib/components/route-details/expense-note/expense-note-context';
	import RealCosts from '$lib/components/route-details/expense-note/RealCosts.svelte';
	import { ROUTE_COSTS } from '$lib/constants/route';
	import { isMobile } from '$lib/services/mediaQuery/screenSize';
	import { getSearchParamsStore, gotoWithParams } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';

	const searchParams = getSearchParamsStore();

	const segments = [
		{
			key: 'allowance' as const,
			label: m.route_details__expense_note_section__edit__allowance(),
		},
		{
			key: 'real' as const,
			label: m.route_details__expense_note_section__edit__real(),
		},
	];

	const expenseNote = getExpenseNoteContext();

	let expenseNoteNextValue = $state({ ...$expenseNote });

	function handleSegmentChange(segment: ComputeMethod) {
		expenseNoteNextValue.computeMethod = segment;
	}

	function handleBack() {
		$expenseNote = expenseNoteNextValue;
		gotoWithParams(ROUTE_COSTS, { ...$searchParams });
	}
</script>

<div
	class="relative top-0"
>
	<div class="py-2 md:p-2 flex flex-row justify-between rd-lg md:bg-white md:shadow-smooth-block md:mb-2">
		<Button
			variant={$isMobile ? 'filled' : 'ghost'}
			color={$isMobile ? 'light' : 'primary'}
			size="md"
			icon="west"
			onclick={handleBack}
			text={m.action__save_close()}
		/>
	</div>
	<div class="pb-4 rd-2 flex flex-col gap-4 rd-lg bg-white shadow-smooth-block p-2 pt-3">
		<div class="text-heading-semibold">{m.route_details__expense_note_section__edit__title()}</div>
		<div class="flex flex-col gap-4 w-full">
			<div class="text-sm text-bold">
				{m.route_details__expense_note_section__edit__compute_method()}
			</div>
			<SegmentControl
				options={segments}
				defaultSelectedOption={$expenseNote.computeMethod}
				onSelectOption={computeMethod => handleSegmentChange(computeMethod)}
			/>
			{#if expenseNoteNextValue.computeMethod === 'allowance'}
				<Allowance bind:expenseNote={expenseNoteNextValue} />
			{/if}
			{#if expenseNoteNextValue.computeMethod === 'real'}
				<RealCosts bind:expenseNote={expenseNoteNextValue} />
			{/if}
		</div>
	</div>
</div>
